export const confirmationList = [
  { value: "1", text: "1. Customer has verified their date of birth" },
  { value: "2", text: "2. Picture on ID resembles the customer" },
  { value: "3", text: "3. ID is valid and in date" },
  {
    value: "4",
    text: "4. A pass hologram logo with no obvious signs of modification",
  },
  {
    value: "5",
    text: "5. Customer informed to bring ID on future visits",
  },
];

export const under18List = [
  {
    value: "1",
    text: "- Identification provided shows the individual to be under 18 years of age",
  },
  {
    value: "2",
    text: "- If the individual has gambled, then funds used have been returned to them",
  },
  { value: "3", text: "- The individual has been refused entry" },
];
